import { render, staticRenderFns } from "./ComingSoonPage.vue?vue&type=template&id=6c71b355&scoped=true&"
import script from "./ComingSoonPage.vue?vue&type=script&lang=js&"
export * from "./ComingSoonPage.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoonPage.vue?vue&type=style&index=0&id=6c71b355&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71b355",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
